import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

import {activityInfo, tabInfo} from './interface'

// 活动中心主页 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100432620
export const activity_center_home = createAsyncThunk(
  'activity_center_home',
  async (arg: {tab?: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'progress_list'
          | 'uncoming_list'
          | 'end_list'
          | 'tab_list'
          | 'default_tab'
        >
      >
    >('/live/activity/activity_center_home', arg, {
      store,
    })
    return resp.data.data
  }
)

// 聚合banner接口 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=38787184
export const banner_aggregation_page = createAsyncThunk(
  'ActivityCenter/banner_aggregation_page',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<InitialStateType, 'progress_list' | 'uncoming_list' | 'end_list'>
      >
    >('/live/room/banner_aggregation_page', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

// 活动列表首页信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90609077
export const getHomePageList = createAsyncThunk(
  'ActivityCenter/getHomePageList',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/room/activity_homepage', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

// 订阅活动 取消订阅 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90609063
export const subscribeActivity = createAsyncThunk(
  'ActivityCenter/subscribeActivity',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/room/subscribe_activity', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

interface InitialStateType {
  progress_list?: activityInfo[]
  uncoming_list?: activityInfo[]
  end_list?: activityInfo[]
  tab_list?: tabInfo[]
  default_tab?: number
  active_tab_item?: tabInfo
  active_tab?: number
  homePage?: any
}

const initialState: InitialStateType = {
  homePage: {},
}

export const ActivityCenterSlice = createSlice({
  name: 'ActivityCenter',
  initialState,
  reducers: {
    setDefaultTab: (state, action: PayloadAction<tabInfo>) => {
      Object.assign(state, {
        active_tab_item: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    // 主页
    builder.addCase(activity_center_home.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    // 活动列表首页信息
    builder.addCase(getHomePageList.fulfilled, (state, action) => {
      Object.assign(state.homePage, action.payload)
    })
  },
})
export default ActivityCenterSlice.reducer
export const ActivityCenterActions = ActivityCenterSlice.actions
